import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import SearchContainer from "../components/Search/SearchContainer";

function Home() {
  return (
    <main className="home-page">
      <Header />
      <SearchContainer />
      <Footer />
    </main>
  );
}

export default Home;
